import { z } from 'zod';
import { TimelineIdentifier } from '../Timeline/types';

const ZodTimelineIdentifier = z.nativeEnum(TimelineIdentifier);

export const ZodZoneConfiguration = z.object({
    id: z.number(),
    display_id: z.number(),
    type: ZodTimelineIdentifier,
    widget_ids: z.array(z.number()),
    default_img: z.nullable(z.string()), //todo: Investigate if this is used anywhere
    duration: z.number(),
    fade_duration: z.number(),
    name: z.string(),
    policy: z.number(),
    shuffle: z.boolean(),
    updated: z.number(),
    width: z.number(),
    height: z.number(),
    x: z.number(),
    y: z.number(),
    z: z.number(),
    css: z.string().nullish(),
    background_color: z.nullable(z.string()),
    on_loop_complete: z.nullable(z.string()),
    on_zone_initialized: z.nullable(z.string()),
});

export type ZoneConfiguration = z.infer<typeof ZodZoneConfiguration>;

export type ZoneInfo = {
    id: number;
    type: string;
    x: number;
    y: number;
    z: number;
    w: number;
    h: number;
    css: string | null;
};
